module.exports = __webpack_public_path__ + "static/media/website-04.46f66816.png";